module.exports = __webpack_public_path__ + "img/ring_g_l_null_null.2c777722.png";